<template>
  <div class="mx-auto py-6">
      <p class="text-center font-semibold text-gray-900 py-2">Für dich gemacht</p>
      <p class="text-center text-gray-900 font-normal py-4">Mit unserem riesigen Sortiment können wir nicht jede Farb- und Größenvariante im Voraus produzieren. Dieses Produkt ist für dich gemacht - schließlich steckt viel Handarbeit in solchen Möbeln.
        Die Lieferzeit wird für Produktion und Transport benötigt.
      </p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>